import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';
import { messages } from './messages';
import style from './style.module.less';

export const PopoverNotesInput = ({ notes = '', setNotes }) => {
  const onAddNotes = useCallback(
    (e) => {
      setNotes(e.target.value);
    },
    [setNotes],
  );

  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationLocationNotesLabel} />
      <div>
        <input className={style['popover-notes']} onChange={onAddNotes} value={notes} />
      </div>
    </div>
  );
};

PopoverNotesInput.propTypes = {
  notes: PropTypes.string,
  setNotes: PropTypes.func.isRequired,
};
